export default "__VITE_ASSET__CT7Vc7B2__"